/* eslint-disable no-underscore-dangle */
import CreateGuid from '../../CreateGuid';
import isMobile from '../isMobile';
import WidgetTypes from './enums/WidgetTypes';

export default class WidgetFactory {
    constructor(type, options) {
        this._type = type;
        this._options = options;
    }

    get type() {
        return this._type;
    }

    get options() {
        return this._options;
    }

    async create() {
        if (!this.type) {
            throw Error('must specify which this.type of widget to create');
        }
        const widgets = this.widgets || (this.widgets = {});
        if (widgets[this.type]) return widgets[this.type];
        const generateIDsforV3Widgets = function (type, isGuidBased) {
            var dynamic_ids = {
                widgetId: type + '_' + CreateGuid(),
                iframeId: type + '_frame_' + CreateGuid(),
                parentDivId: type + '_wrapper_' + CreateGuid()
            };

            var fixed_ids = {
                widgetId: type,
                iframeId: type + '_frame',
                parentDivId: type + '_wrapper'
            };

            return isGuidBased ? dynamic_ids : fixed_ids;
        };
        const ids = generateIDsforV3Widgets(this.type, false);
        const optionsWithIds = { ...this.options, ...ids };
        if (this.type === WidgetTypes.DropDown) {
            const module = await import(/* webpackChunkName: "registerDropDown" */ '../../widgets/standardInvitation/RegisterDropDown');
            const RegisterDropDown = module.default;
            RegisterDropDown();
            widgets[this.type] = new apexchat_dropdown_invitation_client(optionsWithIds);

        } else if (this.type == WidgetTypes.ExitPopup && !isMobile()) {
            const module = await import(/* webpackChunkName: "registerExitPopup" */ '../../widgets/exitpopup/RegisterExitPopup')
            const RegisterExitpopup = module.default;
            RegisterExitpopup();
            widgets[this.type] = new apexchat_exitpopup2_chatwindow_client(optionsWithIds);

        } else if (this.type === WidgetTypes.DOM) {
            const module = await import(/* webpackChunkName: "registerDOM" */ '../../widgets/dom/RegisterDOM')
            const RegisterDOM = module.default;
            RegisterDOM();
            widgets[this.type] = new apexchat_dompopup_chatwindow_client(optionsWithIds);

        } else if (this.type === WidgetTypes.Bar) {
            const module = await import(/* webpackChunkName: "registerBar" */ '../../widgets/bar/RegisterBar')
            const RegisterBar = module.default;
            RegisterBar();
            widgets[this.type] = new apexchat_bar_invitation_client(optionsWithIds);

        } else if (this.type === WidgetTypes.Tab) {
            const module = await import(/* webpackChunkName: "registerTab" */ '../../widgets/tab/RegisterTab')
            const RegisterTab = module.default;
            RegisterTab();
            widgets[this.type] = new apexchat_tab_invitation_client(optionsWithIds);
        } else if (this.type === WidgetTypes.SMS) {
            const module = await import(/* webpackChunkName: "registerSMS" */ '../../widgets/sms/RegisterSMS')
            const RegisterSMS = module.default;
            RegisterSMS();
            widgets[this.type] = new apexchat_sms_invitation_client(optionsWithIds);
        } else if (this.type === WidgetTypes.PreChat) {
            const module = await import(/* webpackChunkName: "registerPreChat" */ '../../widgets/prechat/RegisterPreChat')
            const RegisterPreChat = module.default;
            RegisterPreChat();
            widgets[this.type] = new apexchat_prechat_invitation_client(optionsWithIds);
        } else if (this.type === WidgetTypes.VisitorForm) {
            const module = await import(/* webpackChunkName: "registerVisitorForm" */ '../../widgets/visitorInfo/RegisterVisitorForm')
            const RegisterVisitorForm = module.default;
            RegisterVisitorForm();
            widgets[this.type] = new apexchat_ui_visitor_form_client(optionsWithIds);

        } else if (this.type === WidgetTypes.DynamicVisitorForm) {
            const module = await import(/* webpackChunkName: "registerDynamicVisitorForm" */ '../../widgets/visitorInfo/RegisterDynamicVisitorForm')
            const RegisterDynamicVisitorForm = module.default;
            RegisterDynamicVisitorForm();
            widgets[this.type] = new apexchat_ui_visitor_form_client(optionsWithIds);
        } else if (this.type === WidgetTypes.WebSmsForm) {
            const module = await import(/* webpackChunkName: "registerWebSMS" */ '../../widgets/sms/RegisterWebSMS')
            const RegisterWebSMS = module.default;
            RegisterWebSMS();
            widgets[this.type] = new apexchat_sms_form_client(optionsWithIds);
        } else if (this.type === WidgetTypes.Test) {
            ApexChat.registerTestWidget();
            widgets[this.type] = new apexchat_test_invitation_client(optionsWithIds);
        } else if (this.type == WidgetTypes.VideoGreetInvitation) {
            const module = await import(/* webpackChunkName: "registerVideoGreet" */ '../videogreet/RegisterVideoGreetInvitation')
            const RegisterVideoGreetInvitation = module.default;
            RegisterVideoGreetInvitation();
            widgets[this.type] = new apexchat_video_greet_invitation_client(optionsWithIds);
        }
        return widgets[this.type];
    }
}
